import { clientEnv } from '@retailer-platform/dashboard/env'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

const isLocalDev = clientEnv.PUBLIC_CLIENT_ENVIRONMENT === 'local'

export const catalogAdminSourcePriorityAccessConfiguration: DomainAccessControlConfig = isLocalDev
  ? {}
  : {
      featureToggles: [FeatureToggle.SourcePriorityManagementTool],
      permissions: Permission.SourcePriorityViewAccess,
    }

export const catalogAdminSourcePriorityModifyAccessConfiguration: DomainAccessControlConfig =
  isLocalDev
    ? {}
    : {
        featureToggles: [FeatureToggle.SourcePriorityManagementTool],
        permissions: Permission.SourcePriorityModifyAccess,
      }

export const catalogAdminSourcePriorityApproveAccessConfiguration: DomainAccessControlConfig =
  isLocalDev
    ? {}
    : {
        featureToggles: [FeatureToggle.SourcePriorityManagementTool],
        permissions: Permission.SourcePriorityApproveAccess,
      }
